class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;

    // Carry the "You May Also Like" rail across the swap.
    //
    // The refresh replaces #mini-cart wholesale, and the freshly rendered
    // section emits <cart-recommendations> EMPTY — its contents are gated on
    // `recommendations.performed`, which is only true for the recommendations
    // endpoint, never for a plain section render. The rail was therefore
    // destroyed on every cart update and only refilled once the element's
    // IntersectionObserver fired again, which is the gap you see.
    //
    // Recommendations are not cart state, so the old markup stays valid; it is
    // stashed here and put straight back, leaving no empty frame. The observer
    // still re-fetches in the background, and cart-recommendations.js now only
    // repaints if the markup actually differs — so the common case (same
    // products) produces no second swap either.
    const railBefore = document.querySelector('cart-recommendations');
    const preservedRail = railBefore ? railBefore.innerHTML : '';

    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    if (preservedRail.trim().length) {
      const railAfter = document.querySelector('cart-recommendations');
      if (railAfter && !railAfter.innerHTML.trim().length) {
        railAfter.innerHTML = preservedRail;
      }
    }

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);
